import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ApiService } from '../../../api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-specialization-list',
  templateUrl: './specialization-list.component.html',
  styleUrls: ['./specialization-list.component.scss']
})
export class SpecializationListComponent implements OnInit {

  public list = [];
  message = null;
  class = null;

  constructor(private router: Router, private api: ApiService, private http: HttpClient, @Inject('API_ENDPOINT') private api_endpoint: string) {
  }

  public settings = {
    actions: {
      position: 'right',
      add: false,
      edit: false,
      delete: true
    },
    delete :{
      confirmDelete: true
    },
    columns: {
      stream: {
        title: 'Stream'
      },
      course: {
        title: 'Course'
      },
      specialization: {
        title: 'Specialization'
      },
      _id: {
        title:'Edit',
        type:'html',
        valuePrepareFunction:(cell,row)=>{
          return `<a href="specialization/edit/${row._id}"  class="ng2-smart-action ng2-smart-action-edit-edit ng-star-inserted"><i class="fa fa-pencil"></i></a>&nbsp; `
        },
        filter:false
      },
    },
  };

  ngOnInit() {
    this.http.get<any>(`${environment.apiUrl}/getAllspecialization/`, { headers: {'Userinfo': JSON.stringify({_id: localStorage.getItem('adminSess'), role: localStorage.getItem('userRole')})} }).subscribe(
        data => {
          (data.message == 'Logged Out!') ? this.router.navigateByUrl('/auth/login') : '';
          this.list = data.data;
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
    });
  }

  deleteRecord(event){
    if(confirm('Are You Sure?')){
      this.http.delete<any>(`${environment.apiUrl}/specialization/${event.data._id}`, { headers: {'Userinfo': JSON.stringify({_id: localStorage.getItem('adminSess'), role: localStorage.getItem('userRole')})} }).subscribe(
        data => {
          (data.message == 'Logged Out!') ? this.router.navigateByUrl('/auth/login') : '';
          if(data.status == '500'){
            this.message = data.message;
            this.class = 'btn-primary rounded px-1 py-1';
            window.scrollTo(document.documentElement.clientWidth, 0);
            return 0;
          }else{
            this.message = 'Successfully Deleted';
            this.class = 'btn-success rounded px-1 py-1';
            this.ngOnInit();
          }
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    }
  }

}
